export default __webpack_public_path__ + "static/media/tutorial.8300df27.svg";